export const ACTION_INVENTORY_START = 'ACTION_INVENTORY_START';
export const ACTION_INVENTORY_END = 'ACTION_INVENTORY_END';
export const SEARCH_INVENTORY = 'SEARCH_INVENTORY';
export const SEARCH_INVENTORY_DETAIL = 'SEARCH_INVENTORY_DETAIL';
export const SEARCH_INSPECTION_DETAIL = 'SEARCH_INSPECTION_DETAIL';
export const GET_PAYMENT_DETAILS = 'GET_PAYMENT_DETAILS';
export const GET_AUDIT_TRAIL = 'GET_AUDIT_TRAIL';
export const GET_DRIVER_STATUS = 'GET_DRIVER_STATUS';
export const GET_INVENTORY_COUNT = 'GET_INVENTORY_COUNT';
export const CANCEL_DRIVER_REQUEST = 'CANCEL_DRIVER_REQUEST';
export const INVENTORY_LOG_COUNT = 'INVENTORY_LOG_COUNT';
export const UPDATE_INVENTORY_STATE = 'UPDATE_INVENTORY_STATE';
export const CAR_MOVEMENT = 'CAR_MOVEMENT';
export const SLOT_PREFERENCE_SAVED = 'SLOT_PREFERENCE_SAVED';
export const CHANGE_INVENTORY_STATE_LOCAL = 'CHANGE_INVENTORY_STATE_LOCAL';
export const CHANGE_CAR_MOVEMENT_STATUS_LOCAL =
  'CHANGE_CAR_MOVEMENT_STATUS_LOCAL';
export const SLOT_PREFERENCE_SAVED_LOCAL = 'SLOT_PREFERENCE_SAVED_LOCAL';
export const CHANGE_DRIVER_RETURN_STATUS = 'CHANGE_DRIVER_RETURN_STATUS';
export const LOGISTIC_MOVEMENT_LOCAL = 'LOGISTIC_MOVEMENT_LOCAL';
export const LOGISTIC_MOVEMENT = 'LOGISTIC_MOVEMENT';
export const REASONS = 'REASONS';
export const CHANGE_LIST_PRICING = 'CHANGE_LIST_PRICING';
export const CHANGE_LIST_PRICING_LOCAL = 'CHANGE_LIST_PRICING_LOCAL';
export const CHANGE_TARGET_PRICE = 'CHANGE_TARGET_PRICE';
export const CHANGE_TARGET_PRICE_LOCAL = 'CHANGE_TARGET_PRICE_LOCAL';
export const CHANGE_EGC_VALUE = 'CHANGE_EGC_VALUE';
export const CHANGE_EGC_VALUE_LOCAL = 'CHANGE_EGC_VALUE_LOCAL';
export const CHANGE_PUBLISH_STATUS = 'CHANGE_PUBLISH_STATUS';
export const CHANGE_PUBLISH_STATUS_LOCAL = 'CHANGE_PUBLISH_STATUS_LOCAL';
export const CHANGE_RESERVE_STATUS = 'CHANGE_RESERVE_STATUS';
export const CHANGE_RESERVE_STATUS_LOCAL = 'CHANGE_RESERVE_STATUS_LOCAL';
export const SAVED_UPLOAD_FILE = 'SAVED_UPLOAD_FILE';
export const TIME_SLOTS = 'TIME_SLOTS';
export const ACTION_EXPORT_CSV = 'ACTION_EXPORT_CSV';
export const BULK_UPLOAD_STATUS = 'BULK_UPLOAD_STATUS';
export const BULK_UPLOAD_STATUS_DETAILS = 'BULK_UPLOAD_STATUS_DETAILS';
export const BULK_UPLOAD_STATUS_COUNT = 'BULK_UPLOAD_STATUS_COUNT';
export const UI_RULES = 'UI_RULES';
export const INSPECTION_DATA = 'INSPECTION_DATA';
export const ADDRESS_FILL_START = 'ADDRESS_FILL_START';
export const ADDRESS_FILL = 'ADDRESS_FILL';
export const ADDRESS_FILL_FAIL = 'ADDRESS_FILL_FAIL';
export const GEO_TO_ADDRESS = 'GEO_TO_ADDRESS';
export const REFESH_PAGE = 'REFESH_PAGE';
export const UPDATE_PARKING_SLOT = 'UPDATE_PARKING_SLOT';
export const CHANGE_PARKING_SLOT_LOCAL = 'CHANGE_PARKING_SLOT_LOCAL';
export const UPDATE_INVENTORY_STAGE = 'UPDATE_INVENTORY_STAGE';
export const CHANGE_INVENTORY_STAGE_LOCAL = 'CHANGE_INVENTORY_STAGE_LOCAL';
export const UPDATE_INVENTORY_TYPE = 'UPDATE_INVENTORY_TYPE';
export const CHANGE_INVENTORY_TYPE_LOCAL = 'CHANGE_INVENTORY_TYPE_LOCAL';
export const POST_INSPECTION_DATA = 'POST_INSPECTION_DATA';
export const GET_TEAMS = 'GET_TEAMS';
export const GET_EXTERNAL_DELIVERY_ALLOWED = 'GET_EXTERNAL_DELIVERY_ALLOWED';
export const ACTION_APT_ORDERS = 'GET_APT_ORDERS';
export const ACTION_APT_ORDERS_START = 'GET_APT_ORDERS_START';
export const ACTION_APT_ORDERS_END = 'GET_APT_ORDERS_END';
export const GET_LOCUS_TEAMS = 'GET_LOCUS_TEAMS';
export const ACTION_INVENTORY_ASSETS = 'ACTION_INVENTORY_ASSETS';
export const DOCUMENT_PENDENCY_START = 'DOCUMENT_PENDENCY_START';
export const DOCUMENT_PENDENCY_END = 'DOCUMENT_PENDENCY_END';
export const DOCUMENT_PENDENCY_SEARCH = 'DOCUMENT_PENDENCY_SEARCH';
export const FETCH_FIELD_AUDIT_HISTORY = 'FETCH_FIELD_AUDIT_HISTORY';
export const SUCCESS_FIELD_AUDIT_HISTORY = 'SUCCESS_FIELD_AUDIT_HISTORY';
export const ERROR_FIELD_AUDIT_HISTORY = 'ERROR_FIELD_AUDIT_HISTORY';
export const GET_CONTACT_PERSONS = 'GET_CONTACT_PERSONS';
export const INVENTORY_PENDING_ACTION_STATUS =
  'INVENTORY_PENDING_ACTION_STATUS';
export const UPDATE_SELECTED_INVENTORIES = 'UPDATE_SELECTED_INVENTORIES';
export const INVENTORY_ORDERS_SUCCESS = 'INVENTORY_ORDERS_SUCCESS';
export const CHANGE_PARENT_HUB = 'CHANGE_PARENT_HUB';
export const CHANGE_PARENT_HUB_LOCAL = 'CHANGE_PARENT_HUB_LOCAL';
export const CHANGE_NUMBER_PLATE = 'CHANGE_NUMBER_PLATE';
export const CHANGE_NUMBER_PLATE_LOCAL = 'CHANGE_NUMBER_PLATE_LOCAL';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
